import dayjs from 'dayjs'

export const parseIsoToTimestampMS = (date: string | undefined) => dayjs(date).valueOf()
